require("bootstrap");
require("lazyload");
require("jquery-match-height");
require("jquery-parallax.js");
require("jquery-easing");

/**
 * Cookies Settings
 */
global.Cookies = require("js-cookie");

/**
 * Lazyload for images
 */
let images = document.querySelectorAll("img.lazy");
lazyload(images);

/**
 * Ajax with Laravel CSRF token
 */
const _token = $('meta[name="csrf-token"]').attr("content");
$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": _token,
  },
});
